export const assertNotUndefined = (...args) => {
  for (const arg of args) {
    if (arg === undefined) {
      // Object.keys(arg)[0] prints the variable name
      console.error('Assert undefined check failed for variable');
      console.trace();
    }
  }
};
